/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useState, useEffect } from "react";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import { IWechatPayReq } from "@/app/csr-src/apis/checkout/checkout.interface";
import { getWechatPayResult } from "@/app/csr-src/apis/checkout/checkout.api";
import { WechatPaymentStatus } from "@/app/csr-src/apis/checkout/constants/constants";

import { Button } from "@mui/material";
import UKToast from "@/common-components-src/components/UKToast/index";;

import WechatDialog from "../wechatDialog";
import { IWechatPayRes } from "@/app/csr-src/apis/checkout/checkout.interface";

import Styles from "./btn.module.scss";

interface WechatProps {
  onSubmit: () => any; // 提单
  toOrderList: () => void; // 支付失败后的回调
  onLoadingResult: (data: any, closeLoading: () => void) => any;
}
// 定时器
let interval: any = null;
const WechatPay: FC<WechatProps> = observer((props) => {
  const { t } = useTranslation();
  const { checkoutStore } = useStores();
  const [wechatPayModalOpen, setWechatPayModalOpen] = useState(false);
  const [wechatUrl, setWechatUrl] = useState("");
  const [totalTime, setTotalTime] = useState(0); // 倒计时, 单位s

  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(false);

  // 关闭loading
  const closeLoading = () => {
    clearInterval(interval); // 清除定时器
    setLoading(false);
    checkoutStore.setSafetyLoading(false);
    setWechatPayModalOpen(false);
    console.log("clear interval");
  };

  // 关闭loading，不提示报错
  const onPayError = () => {
    closeLoading();
    props.toOrderList(); // 支付失败，跳转到订单列表
  };

  /**
   *
   * 提单，并唤起支付
   *
   */
  const handleSubmit = async () => {
    setLoading(true);
    checkoutStore.setSafetyLoading(true);

    // 提单接口在父组件中统一处理
    const res: any = await props.onSubmit();
    console.log(res, "submit response");

    // 如果提单成功，则唤起支付
    if (res.success) {
      try {
        const payInfo = JSON.parse(res.data.payInfo);
        setWechatUrl(payInfo.payload);
        setTotalTime(Number(payInfo.timeout));
        setWechatPayModalOpen(true);
        getIntervalWechatResult({
          txnSeqno: (checkoutStore.payResult as any).id,
          payEnum: (checkoutStore.currentPayInfo as any).payEnum,
          outerSeqno: payInfo.checkoutId,
        });
      } catch (error) {
        onPayError();
      }
      return;
    }

    closeLoading();
  };

  /**
   * 轮询微信支付结果，5分钟，每2秒查询一次，一共查询20 * 5次
   * */
  const getIntervalWechatResult = (params: IWechatPayReq) => {
    let retry = totalTime / 3;
    interval = setInterval(async () => {
      const result = await fetchWechatPayResult(params);
      /** 支付完成 */
      if (result === WechatPaymentStatus.PAID) {
        clearInterval(interval);
        redirectResult();
        return;
      }

      if (
        result === WechatPaymentStatus.FAILED ||
        result === WechatPaymentStatus.EXPIRED ||
        result === WechatPaymentStatus.DECLINED ||
        result === WechatPaymentStatus.VERIFY ||
        result === WechatPaymentStatus.CANCELLED ||
        retry === 1
      ) {
        onPayError();
        return;
      }

      retry--;
    }, 3000);
  };

  // 查询微信支付结果
  const fetchWechatPayResult = async (params: IWechatPayReq) => {
    const res: IWechatPayRes = await getWechatPayResult(params);
    return res?.outerTxnStatus;
  };

  // 后端redirect接口
  const redirectResult = async () => {
    const requestData = {
      txnSeqno: (checkoutStore.payResult as any).id,
      txnScene: "Consumption",
      payMethod: Number(checkoutStore.payMethod),
    };
    props.onLoadingResult(requestData, closeLoading);
  };

  return (
    <>
      {/* 提单按钮 */}
      <Button
        fullWidth
        variant="contained"
        className={Styles.commonBtn}
        disabled={loading || checkoutStore.submitOrderBtnDisabled}
        onClick={handleSubmit}
      >
        {t("checkout.common.continue")}
      </Button>

      {wechatUrl && (
        <WechatDialog
          wechatUrl={wechatUrl}
          open={wechatPayModalOpen}
          onClose={onPayError}
          cuntdownTime={totalTime}
        />
      )}
    </>
  );
});

export default WechatPay;
